<script setup>
import { cn } from '@/lib/utils'
import { inject, ref } from 'vue'

const props = defineProps({
  class: { type: String, default: '' },
})

const imageLoadingStatus = inject('imageLoadingStatus', ref('idle'))
</script>

<template>
  <div
    v-if="imageLoadingStatus === 'idle' || imageLoadingStatus === 'error'"
    :class="cn('flex h-full w-full items-center justify-center rounded-full bg-brand-soft text-brand-soft-text font-bold', props.class)"
  >
    <slot />
  </div>
</template>
